<app-server-down></app-server-down>
<div class="app__loading" [class.--display]="loadingFullScreen$ | async">
    <mat-spinner class="app__loading__spinner" [diameter]="60"></mat-spinner>
</div>
<router-outlet></router-outlet>
